import React, { useContext, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import {
  Alert,
  Card,
  Chip,
  Divider,
  Paper,
  Skeleton,
  Tooltip,
} from '@mui/material'
import EventIcon from '@mui/icons-material/Event'
import { ClientPortalContext } from '../../ClientPortal'
import API from '../../../../../services/API'
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn'
import moment from 'moment'
import { useNavigate } from 'react-router-dom'

const UpcomingEvents = () => {
  const { upcomingEvents, loading } = useContext(ClientPortalContext)

  const navigate = useNavigate()

  return (
    <Grid item xs={12} md={6} lg={4}>
      <Stack gap={1}>
        <Typography variant="title2">Upcoming Events</Typography>
        {loading ? (
          <Skeleton variant="rectangular" height={120} />
        ) : (
          <Stack gap={1}>
            {upcomingEvents.length === 0 && (
              <Alert severity="info">No Upcoming Events</Alert>
            )}
            {upcomingEvents.map((event) => (
              <Grid
                key={event._id}
                container
                paddingX={1}
                paddingY={1.5}
                onClick={() => navigate(`/events/${event._id}`)}
                sx={{ cursor: 'pointer' }}
                border="solid 1px"
                borderColor="anGreen.main"
                borderRadius={1}
              >
                <Grid item xs={12} md={8}>
                  {event.title}
                </Grid>
                <Grid item xs={12} md={4}>
                  <Stack gap={1} direction="row">
                    <Chip
                      size="small"
                      label={moment(event.startDate).format('Do MMM YYYY')}
                      sx={{ borderRadius: 1, width: '100%' }}
                      color="anMainBlue"
                      icon={<EventIcon />}
                    />
                    {event.EMPApproved && (
                      <Tooltip title="Medical Plan Available">
                        <AssignmentTurnedInIcon color="success" />
                      </Tooltip>
                    )}
                  </Stack>
                </Grid>
              </Grid>
            ))}
          </Stack>
        )}
      </Stack>
    </Grid>
  )
}

export default UpcomingEvents
